import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {inject} from '@angular/core';
import {AuthServiceService} from '../service/auth-service.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/autenticar')) {
    return next(req);
  }

  const token = localStorage.getItem('tokenParceiros');

  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(clonedRequest).pipe(
      catchError((erro: HttpErrorResponse) => {
        if (erro.status === 401) {
          localStorage.removeItem('tokenParceiros');
          localStorage.removeItem('permissoesParceiros');
          localStorage.removeItem('empresasParceiros');
        }
        return throwError(() => erro);
      })
    );
  }

  return next(req);
};

